export default __webpack_public_path__ + "static/media/device-EL-128x128.364b0c7e.png";